import moment from 'moment';
import getItemStyles from '../../../utils/item-styles';
import fixAmAndPm from '../../../../../utils/fixAmAndPm';
import ignoreDummyComments from '../../../../../utils/ignoreDummyComments';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck';

/**
 *
 * @param {String} startTime
 * @param {*} dayType
 * @param {*} resource
 */
const generateTour = (startTime, dayType, resource, startDate, scheduleType, scheduleFormat, timeZoneOffset,securityLevels) => {
    const validateStatus = (status) => {
        return status != 1;/*None*/  
      }
    const { rId  } = resource;
    const { rdtId } = dayType;

    const { tourId, duration, notificationComment, tourComment, abbreviation, isApproved,tourContract } = dayType.tour;
    let hasComment = false;
    if ( ignoreDummyComments(notificationComment || tourComment ) ) {
        hasComment = true;
    }
    const isOvertime = tourHasOvertime(dayType);
    let tourStyle;
    if (isOvertime) {
        tourStyle = getItemStyles('overtime');
    } else tourStyle = getItemStyles('tour');
    const adjustedTitle = createTitle(abbreviation, startTime, duration, startDate, scheduleType, scheduleFormat, timeZoneOffset);

    if (daylightSavingsCheck(startDate) === 'springForwardDay'
        || (daylightSavingsCheck(moment(startDate)) === false
        && daylightSavingsCheck(moment(startDate).add(scheduleFormat - 1, 'days')) === true)
    ) {
        startTime = startTime.add(timeZoneOffset + 60, 'minutes');  // DST fix: only temporary, won't work in all timezones
    } else {
        startTime = startTime.add(timeZoneOffset, 'minutes'); // necessary for each day the rest of the year
    }
    let strTooltip = adjustedTitle;
    if (securityLevels) {
        strTooltip+="\n";
        strTooltip += validateStatus(securityLevels.scheduleTourContract) ? 'Tour Contract: '+ tourContract : ''
    }

    let tour = {
        id: tourId,
        rdtId,
        itemType: 'tour',
        group: rId,
        title:  strTooltip,
        tooltipText: adjustedTitle,
        start_time: moment(startTime).startOf('day'),
        end_time: moment(startTime).endOf('day'),
        date: moment(startTime).format('MM-DD-YYYY'),
        backgroundColor: dayType.tour.isApproved ? "gray" : tourStyle.backgroundColor,
        borderStyle: tourStyle.borderStyle,
        borderColor: hasComment ? 'red' : tourStyle.borderColor,
        isApproved
    };

    return tour;
}

const createTitle = (abbreviation, startTime, duration, startDate, scheduleType, scheduleFormat, timeZoneOffset) => {
    let DSTNeutralStartTime = moment.utc(startTime).clone();

    let adjustedTime = fixAmAndPm(moment(DSTNeutralStartTime).format('h:mma')) + '-'
        + fixAmAndPm(moment(moment(DSTNeutralStartTime).add(duration, 'hours')).format('h:mma'));
    return adjustedTime + ' ' + abbreviation;
}

const tourHasOvertime = (dayType) => {

    // If the title has overtime it must have overtime
    if ( dayType.title && (dayType.title.includes('Overtime') || dayType.title.includes('OT')) ) {
        return true;
    }

    // Reading whether tourPayTransactions have a value of OT and thus an OT tour
    if (dayType.tour.tourPayTransactions) {
        if (typeof(dayType.tour.tourPayTransactions[0]) === 'object') {
            for (let tourPayTransactions of dayType.tour.tourPayTransactions) {
                if (tourPayTransactions.code === 'OT') {
                    return true;
                }
            }
        } else {
            for (let code of dayType.tour.tourPayTransactions) {
                if (code === 'OT') {
                    return true;
                }
            }
        }
    }
    return false;
}

export default generateTour;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/generate-timeline/generateTour.js